/**
 * Permission Error Types for Frontend
 * Mirrors backend types for consistent error handling
 */

export enum PermissionErrorType {
  NO_ACCESS_TO_CHATBOT = 'NO_ACCESS_TO_CHATBOT',
  NO_ACCESS_TO_FEATURE = 'NO_ACCESS_TO_FEATURE',
  ACTION_NOT_PERMITTED = 'ACTION_NOT_PERMITTED',
  PERMISSIONS_NOT_CONFIGURED = 'PERMISSIONS_NOT_CONFIGURED',
}

export interface OwnerInfo {
  name: string;
  email: string;
}

export interface PermissionErrorPayload {
  errorType: PermissionErrorType;
  chatbotId?: string;
  feature?: string;
  action?: string;
  currentPermissions?: Record<string, boolean>;
  owner: OwnerInfo;
  message: string;
}

export interface PermissionErrorResponse {
  statusCode: number;
  error: string;
  message: string;
  permissionError?: PermissionErrorPayload;
}
